import "./FounderSection.css";

import founder from "../../assets/story/founder.jpg";

const FounderSection = () => {
  return (
    <section className="founder">

      <div className="container">

        <div className="founder-wrapper">

          {/* Left Content */}

          <div className="founder-content">

            <span>OUR FOUNDER</span>

            <h2>
              A Dream Woven Into
              <br />
              Every Saree
            </h2>

            <p>
              What began as a small family passion has grown into a
              celebration of India's timeless handloom heritage.
              Every saree at Yadnya Handloom represents our dedication
              to preserving centuries-old weaving traditions while
              empowering skilled artisans.
            </p>

            <p>
              Our vision has always been simple—to bring authentic,
              handcrafted masterpieces directly to women who appreciate
              elegance, craftsmanship, and cultural heritage.
            </p>

            <div className="founder-sign">

              <h3>Yadnya Handloom</h3>

              <small>Founder & Creative Director</small>

            </div>

          </div>

          {/* Right Image */}

          <div className="founder-image">

            <div className="founder-placeholder">

    <span>Founder Image</span>

  </div>
          </div>

        </div>

      </div>

    </section>
  );
};

export default FounderSection;